import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { AppInsightsProvider } from 'services';
import App from './App';

const app = ReactDOM.createRoot(document.getElementById('app') as HTMLElement);
app.render(
	<AppInsightsProvider cloudRoleName="detroit-spa">
		<Router>
			<App />
		</Router>
	</AppInsightsProvider>,
);
